"use client";

import React from "react";
import { useTranslations } from "@/providers/TranslationsProvider";

/**
 * The top of /join for a visitor who isn't signed in: what the page offers
 * and a way to sign in, which brings them back here to the form.
 */
export default function JoinHero({ signInUrl }: Readonly<{ signInUrl: string }>) {
  const { t } = useTranslations();

  return (
    <header className="text-center">
      <h1 className="text-[22px] sm:text-[32px] font-semibold leading-[1.125] tracking-[0.004em] text-[var(--foreground)]">
        {t("join.title", "Join {{app}} as a doctor")}
      </h1>
      <p className="mt-3 text-[15px] sm:text-[17px] leading-[1.5] text-[var(--foreground-secondary)]">
        {t("join.subtitle", "Offer online sessions to patients in their own language.")}
      </p>
      <a
        href={signInUrl}
        className="mt-6 inline-flex items-center justify-center h-12 px-7 rounded-full bg-[#0071E3] hover:bg-[#0077ED] text-white text-[16px] font-medium"
      >
        {t("join.landing.sign in to apply", "Sign in to apply")}
      </a>
      <p className="mt-3 text-[13px] text-[var(--foreground-tertiary)]">
        {t("join.landing.sign in note", "You sign in with your mobile number, no password needed.")}
      </p>
    </header>
  );
}
